import { createBrowserHistory } from 'history';
import { BASE_PATH } from './basePath';

export const history = createBrowserHistory({ basename: BASE_PATH });
